var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstructionMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "78.222069mm",
    height: "78.221886mm",
    viewBox: "0 0 78.222069 78.221886",
    id: "svg840",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs837"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-20.14618,-75.476796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 6.51007,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path42322",
    cx: 59.257214,
    cy: 114.58774,
    rx: 35.855999,
    ry: 35.855907
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1000",
    transform: "matrix(0.0918179,0,0,0.0918179,35.751832,91.082311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g925"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 442.547,143.877 c -3.46,-4.855 -9.054,-7.737 -15.016,-7.737 h -70.827 c -7.511,0 -14.271,4.556 -17.092,11.517 L 291.55,266.289 H 248.298 L 230.19,97.342 C 229.186,87.971 221.278,80.866 211.853,80.866 H 18.442 C 8.257,80.866 0,89.123 0,99.308 0,109.493 8.257,117.75 18.442,117.75 h 8.1 v 150.433 c -2.448,-1.2 -5.19,-1.893 -8.1,-1.893 C 8.257,266.289 0,274.546 0,284.731 v 40.582 c 0,7.347 4.308,13.673 10.525,16.637 11.122,-10.395 26.04,-16.776 42.427,-16.776 h 201.657 l -2.358,-22.002 h 51.725 c 7.511,0 14.271,-4.556 17.092,-11.517 L 369.13,173.023 h 48.899 l 12.135,17.022 h 45.295 z M 85.227,229.085 H 63.425 V 117.75 h 21.802 z m 36.883,0 V 117.75 h 73.172 l 11.933,111.335 z",
    id: "path923"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g931"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 433.83,208.487 v 0.001 46.981 c 33.643,14.851 60.944,40.235 78.17,72.576 V 208.487 Z",
    id: "path929"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g937"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 366.119,343.617 H 52.952 c -24.128,0 -43.759,19.629 -43.759,43.759 0,24.13 19.631,43.759 43.759,43.759 h 313.166 c 24.128,0 43.759,-19.629 43.759,-43.759 0,-24.13 -19.63,-43.759 -43.758,-43.759 z m -308.937,61.42 c -9.754,0 -17.662,-7.908 -17.662,-17.662 0,-9.754 7.908,-17.662 17.662,-17.662 9.754,0 17.662,7.908 17.662,17.662 0,9.755 -7.908,17.662 -17.662,17.662 z m 307.005,-10e-4 c -9.754,0 -17.662,-7.908 -17.662,-17.662 0,-9.754 7.908,-17.662 17.662,-17.662 9.754,0 17.662,7.908 17.662,17.662 0,9.754 -7.907,17.662 -17.662,17.662 z",
    id: "path935"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g941"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g943"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g945"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g947"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g949"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g951"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g953"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g955"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g957"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g959"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g961"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g963"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g965"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g967"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g969"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionMachine);
export default __webpack_public_path__ + "static/media/construction_machine.cae3004e980db54cce6044ba84dd9892.svg";
export { ForwardRef as ReactComponent };